import objectFitImages from 'object-fit-images'

if (window.document.documentMode) {
  const images = document.querySelectorAll('.of-image')
  objectFitImages(images)
}
